import React from "react";
import { cn } from "app/_components/components/utils";

type CircleProps = {
  size?: number;
  strokeWidth?: number;
  color?: string;
  duration?: string | number;
  animate?: boolean;
} & React.SVGProps<SVGSVGElement>;

const Circle: React.FC<CircleProps> = ({
  size = 16,
  strokeWidth = 2,
  color = "#F59E02",
  duration = "7.8s",
  animate = true,
  ...props
}) => {
  const half = size / 2;
  const radius = Math.max(0, half - strokeWidth / 2);
  const circumference = 2 * Math.PI * radius;
  const dur = typeof duration === "number" ? `${duration}s` : duration;

  const className = `gmn-circle-anim`;
  const propClass = (props as any).className ?? "";
  const ariaLabel = (props as any)["aria-label"] ?? (props as any).ariaLabel;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      aria-hidden={!ariaLabel}
      role={ariaLabel ? "img" : undefined}
      {...props}
      className={cn(className, propClass)}
    >
      <style>{`
        @keyframes gmn-dash {
          0% { stroke-dashoffset: ${circumference}; }
          12% { stroke-dashoffset: ${circumference * 0.75}; }
          25% { stroke-dashoffset: ${circumference * 0.37}; }
          37% { stroke-dashoffset: ${circumference * 0.18}; }
          50% { stroke-dashoffset: ${circumference * 0.12}; }
          62% { stroke-dashoffset: ${circumference * 0.18}; }
          75% { stroke-dashoffset: ${circumference * 0.37}; }
          88% { stroke-dashoffset: ${circumference * 0.75}; }
          100% { stroke-dashoffset: ${circumference}; }
        }
        .${className} .gmn-bg { 
          stroke: #E5E7EB; 
          stroke-linecap: round; 
        }
        .${className} .gmn-progress {
          stroke: ${color};
          stroke-linecap: round;
          stroke-dasharray: ${circumference};
          stroke-dashoffset: ${circumference};
          ${animate ? `animation: gmn-dash ${dur} ease-in-out infinite;` : ""}
        }
      `}</style>
      <circle
        className="gmn-bg"
        cx={half}
        cy={half}
        r={radius}
        fill="none"
        strokeWidth={strokeWidth}
        transform={`rotate(270 ${half} ${half})`}
      />
      <circle
        className="gmn-progress"
        cx={half}
        cy={half}
        r={radius}
        fill="none"
        strokeWidth={strokeWidth}
        transform={`rotate(270 ${half} ${half})`}
      />
    </svg>
  );
};

export default Circle;
